import classNames from 'classnames';
import React from 'react';
import styles from "./footer-buttons.module.css";
/** React prop interface for FooterButton component. */

/**
 * ### The FooterButtons component.
 *
 * @remarks
 * This component requires global CSS.
 * You must add this import to your application's `_app.tsx` global CSS import manifest:
 *
 * @example
 * `@import '~@udemy/react-structure-components/dist/react-structure-components.global.css';`
 */
export const FooterButtons = _ref => {
  let {
    alignment = 'right',
    ...htmlProps
  } = _ref;
  const footerButtons = /*#__PURE__*/React.createElement("div", Object.assign({}, htmlProps, {
    className: classNames(htmlProps.className, styles['footer-btns'], 'ud-footer-btns'),
    style: { ...htmlProps.style,
      textAlign: alignment
    }
  })); // Modal makes the footer sticky at mobile breakpoint.
  // The spacer ensures the modal content does not overlap the sticky footer.

  return /*#__PURE__*/React.createElement(React.Fragment, null, footerButtons, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['footer-btns-spacer'], 'ud-footer-btns-spacer')
  }));
};
//# sourceMappingURL=footer-buttons.react-component.js.map